import { observer } from 'mobx-react';
import { FC, Fragment } from 'react';

import { Banner, Button, Modal, Stack, Text } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';

import { PhoneNumbersStore } from '../../stores/phone-numbers.store';

export const NumberConfirm: FC = observer(() => {
    const [store] = useDependencies(PhoneNumbersStore);
    const openDialpad = () => open(store.dialpadOfficeSettingsUrl);

    return (
        <Fragment>
            <Modal.Header onClose={store.closeModal} title="Phone Number Added" />
            <Modal.Content scrollable={false}>
                <Text>
                    Your phone number was successfully added! To begin receiving calls on this new
                    tracking number, please be sure to assign this number in Dialpad.
                    {!store.dialpadOfficeSettingsUrl &&
                        ' Please contact the Admin on your team who has access to Dialpad.'}
                </Text>
                <Banner
                    className="m-t-2"
                    status="warning"
                    icon
                    title="If you do not assign this number in Dialpad you will be unable to receive calls to this number."
                />
            </Modal.Content>
            <Modal.Footer align="right">
                <Stack spacing={2}>
                    <Button onClick={store.closeModal}>Close</Button>
                    {store.dialpadOfficeSettingsUrl && (
                        <Button
                            primary
                            iconName="open_in_new"
                            iconPosition="right"
                            onClick={openDialpad}
                        >
                            Open Dialpad
                        </Button>
                    )}
                </Stack>
            </Modal.Footer>
        </Fragment>
    );
});
